module.exports = __webpack_public_path__ + "static/image 118-f0f666e1ccba81b0ee0dbc87d06256ba.jpg";